import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { Constants } from "../libs/Constants";
import { getList } from "../libs/dbFunctions";
import "./charts.scss";
import BarChart from "./Charts/BarChart";

const PeoplePerDeparment = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [barData, setBarData] = useState(null);
  const [people, setPeople] = useState({
    new_withdraw: 0,
    new_participants: 0,
    employee: {
      total: 0,
      part: 0,
      non_part: 0,
      departments: [],
    },
  });

  function loadChartData() {
    //load Barchart data
    let datasets = [
      {
        label: "Employee Count",
        barPercentage: 1,
        categoryPercentage: 0.5,
        backgroundColor: [],
        borderRadius: "4px 4px 0px 0px",
        borderWidth: 1,
        data: [],
      },
      {
        label: "Employees Participating in ESPP",
        barPercentage: 1,
        categoryPercentage: 0.5,
        backgroundColor: [],
        borderRadius: "4px 4px 0px 0px",
        borderWidth: 1,
        data: [],
      },
    ];
    let departments = people.employee.departments;
    let labels = [];
    // sort department by total
    departments.sort((a, b) => b.total - a.total);
    let max_department = 5;
    let others_total = 0;
    let others_part = 0;
    for (let i = 0; i < departments.length; i++) {
      let dept = departments[i];
      if (i < max_department) {
        labels.push(dept.name);
        datasets[0].data.push(dept.total);
        datasets[0].backgroundColor.push("#423E60");
        datasets[1].data.push(dept.part);
        datasets[1].backgroundColor.push("#4E729B");
      } else {
        if (labels.includes("Others")) {
          others_total += dept.total;
          others_part += dept.part;
        } else {
          labels.push("Others");
        }
      }
    }
    if (labels.includes("Others")) {
      datasets[0].data.push(others_total);
      datasets[0].backgroundColor.push("#423E60");
      datasets[1].data.push(others_part);
      datasets[1].backgroundColor.push("#4E729B");
    }
    setBarData({ labels, datasets });
    setIsLoading(false);
  }

  async function loadPeopleDetails() {
    try {
      let params = {
        summaryType: Constants.SUMMARY_TYPE.PEOPLE,
        startdate: props.period.periodStartdate,
        enddate: props.period.periodEnddate,
      };
      console.log("params", params);
      let peopleDetails = await getList(
        Constants.dbTypes.SUMMARY,
        props.activeCompany,
        params
      );
      if (peopleDetails) {
        setPeople(peopleDetails);
      }
    } catch (e) {
      toast.error(e);
    }
  }

  useEffect(() => {
    setIsLoading(true);
    if (people) loadChartData();
  }, [people]);

  useEffect(() => {
    loadPeopleDetails();
  }, [props.period]);

  return (
    <div className="dsp-entr-box">
      <h4>Participation per Department</h4>
      <Row className="p-3" style={{ height: "200px" }}>
        <Col sm={12}>
          {barData && (<BarChart data={barData} />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PeoplePerDeparment;
